// extracted by mini-css-extract-plugin
export var currencyInput = "_kt-1";
export var currencySymbol = "_kt-0";